import { render } from "./DataList.vue?vue&type=template&id=2d308efb"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Pages/DataList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d308efb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d308efb', __exports__)) {
    console.log('reload')
    api.reload('2d308efb', __exports__)
  }
  
  module.hot.accept("./DataList.vue?vue&type=template&id=2d308efb", () => {
    console.log('re-render')
    api.rerender('2d308efb', render)
  })

}


export default __exports__